import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ProductType } from 'types';
import { Modal, FormattedPrice, AddToCart } from 'components/shared';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  product: ProductType.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onAddToCart: PropTypes.func.isRequired,
};

const StyledAddToCart = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 400px;
`;

const StyledHeading = styled.div`
  margin-bottom: 32px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-position: 50% 50%;
  background-size: cover;
  height: 150px;
  overflow: hidden;
`;

const StyledHeadingOverlay = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: end;
  justify-content: flex-end;
  background-color: rgba(11, 31, 38, 0.85);
  padding: 30px 50px;
  width: 100%;
  height: 100%;
`;

const StyledHeadingName = styled.div`
  margin-bottom: 10px;
  padding: 0;
  text-align: center;
  color: #fff;
`;

const StyledHeadingPrice = styled.div`
  display: block;
  padding: 0 24px;
  text-align: center;
  color: #929294;
`;

function AddToCartModal({ isOpen, onRequestClose, product, onAddToCart }) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Add to Cart"
    >
      <StyledAddToCart
        data-test-id={isOpen ? 'product-buy-modal-open' : ''}
        className="AddToCartModal"
      >
        <StyledHeading
          className="AddToCartModal__Heading"
          style={{
            backgroundImage:
              product.bannerImageUrl &&
              `url('${product.bannerImageUrl.thumbnail}')`,
          }}
        >
          <StyledHeadingOverlay className="AddToCartModal__HeadingOverlay">
            <StyledHeadingName className="AddToCartModal__Name">
              {product.name}
            </StyledHeadingName>

            <StyledHeadingPrice className="AddToCartModal__Price">
              <FormattedPrice
                unitPrice={product.price}
                append={` / ${product.quantityVariable}`}
              />
            </StyledHeadingPrice>
          </StyledHeadingOverlay>
        </StyledHeading>

        <AddToCart
          product={product}
          onAddToCart={onAddToCart}
          afterAddToCart={onRequestClose}
        />
      </StyledAddToCart>
    </Modal>
  );
}

AddToCartModal.propTypes = propTypes;

export default AddToCartModal;



// WEBPACK FOOTER //
// ./src/components/shared/AddToCartModal/AddToCartModal.jsx